import { axiosSarlaft } from "@/plugins/axios";
import type { AxiosResponse } from "axios";

export interface ActivityFilters {
  search?: string;
}

export const activityService = {
  getAll: async (filters: ActivityFilters = {}): Promise<any> => {
    try {
      const params = new URLSearchParams();

      if (filters.search) {
        params.append("search", filters.search);
      }
      const response: AxiosResponse<any, any> = await axiosSarlaft.get(
        `/actividades-ciiu?${params.toString()}`,
        {}
      );
      return response.data.map((x: any) => ({
        value: x.id,
        label: x.descripcion,
      }));
    } catch (error) {
      throw error;
    }
  },
};
